export enum EmbeddableUrlKind {
    Unknown,
    YouTubeVideo,
    YouTubePlaylist,
}
